import React, { useEffect, useState } from 'react';
import liff from '@line/liff';
import NAVIGATIONBAR from "../Components/Login/navigationBar";
import NEWSTAB from "../Components/Login/newsTab";
import LiffLoginForm from "../Components/Login/LiffloginForm";
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import LIFFInspectorPlugin from "@line/liff-inspector";
interface EnvType {
    REACT_APP_LIFF_APP_ID: string;
}

interface Profile {
    userId: string;
    displayName: string;
    pictureUrl?: string;
    statusMessage?: string;
}

function LiffApp() {
    const navigate = useNavigate();
    const [isLiffInitialized, setIsLiffInitialized] = useState(false);
    const [profile, setProfile] = useState<Profile | null>(null);
    const [lineToken, setLineToken] = useState<string | null>(null);
    const [idToken, setIdToken] = useState<any | null>(null);
    const [cookies, setCookie] = useCookies(['authority', 'access_token', 'idToken']);
    const params = new URLSearchParams(window.location.search);
    const env = process.env as unknown as EnvType;
    const liff_id = env.REACT_APP_LIFF_APP_ID;

    // const accessToken = "取得したアクセストークン";
    useEffect(() => {
        async function initializeLiff() {
            try {
                liff.use(new LIFFInspectorPlugin());
                await liff.init({ liffId: liff_id });
                setIsLiffInitialized(true);

                const token = liff.getAccessToken();
                setLineToken(token);

                if (liff.isLoggedIn()) {
                    const userProfile = await liff.getProfile();
                    setProfile(userProfile);
                    const idToken = liff.getIDToken();
                    setIdToken(idToken);
                    setCookie('idToken', idToken, { path: '/', maxAge: 3600 });
                } else {
                    liff.login();
                }
            } catch (error) {
                console.error('LIFF initialization failed:', error);
            }
        }
        initializeLiff();
    }, [idToken]);

    return (
        <>
            <div className="wrapper">
                <NAVIGATIONBAR />
                <main className="login-main">
                    <LiffLoginForm idToken={idToken} />
                    <NEWSTAB />
                </main>
            </div>
        </>
    );
}

export default LiffApp;
